import { useRef } from "react";
import styled from "styled-components";
import ProductCard from "../ProductCard/ProductCard";

const ProductSlider = ({
  data,
  producturl,
  handleProductRoute,
  handleAddToWishList,
  handleAddCart,
}) => {
  const sliderRef = useRef(null);

  const handleNext = () => {
    if (sliderRef.current) {
      const cardWidth = sliderRef.current.children[0]?.offsetWidth || 250;
      sliderRef.current.scrollBy({
        left: cardWidth + 24, // Card width + gap
        behavior: "smooth",
      });
    }
  };

  const handlePrev = () => {
    if (sliderRef.current) {
      const cardWidth = sliderRef.current.children[0]?.offsetWidth || 250;
      sliderRef.current.scrollBy({
        left: -(cardWidth + 24), // Card width + gap
        behavior: "smooth",
      });
    }
  };

  return (
    <ResponsiveContainer>
      {/* Products Slider Container */}
      <div className="relative">
        {/* Navigation Buttons (Always visible, inside container) */}
        <button
          onClick={handlePrev}
          aria-label="Previous Products"
          className="absolute left-[12px] top-[35%] -translate-y-1/2 z-10 w-10 h-10 bg-white rounded-full shadow-lg border border-gray-100 flex items-center justify-center hover:bg-gray-50 transition-all duration-300"
        >
          <svg
            className="w-5 h-5 text-gray-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>

        <button
          onClick={handleNext}
          aria-label="Next Products"
          className="absolute right-[12px] top-[35%] -translate-y-1/2 z-10 w-10 h-10 bg-white rounded-full shadow-lg border border-gray-100 flex items-center justify-center hover:bg-gray-50 transition-all duration-300"
        >
          <svg
            className="w-5 h-5 text-gray-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>

        {/* Products Scroll Track (No Horizontal Scrollbar!) */}
        <ScrollTrack ref={sliderRef}>
          {data?.getPopularProduct?.map((item) => (
            <CardWrapper key={item.product_id}>
              <ProductCard
                item={item}
                producturl={producturl}
                handleProductRoute={handleProductRoute}
                handleAddToWishList={handleAddToWishList}
                handleAddCart={handleAddCart}
              />
            </CardWrapper>
          ))}
        </ScrollTrack>
      </div>
    </ResponsiveContainer>
  );
};

export default ProductSlider;

const ResponsiveContainer = styled.div`
  margin: 0 auto;
  width: 100%;
  overflow: hidden;
`;

const ScrollTrack = styled.div`
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  gap: 24px;
  padding-bottom: 16px;
  margin-left: -16px;
  margin-right: -16px;
  padding-left: 16px;
  padding-right: 16px;
  scroll-behavior: smooth;

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
  
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
`;

const CardWrapper = styled.div`
  flex-shrink: 0;
  width: calc(100% - 16px);
  scroll-snap-align: start;

  @media (min-width: 640px) {
    width: calc(50% - 12px);
  }
  @media (min-width: 768px) {
    width: calc(33.333% - 16px);
  }
  @media (min-width: 1024px) {
    width: calc(33.333% - 16px); /* 3 cards on smaller laptops */
  }
  @media (min-width: 1200px) {
    width: calc(25% - 18px); /* 4 cards on standard laptops */
  }
  @media (min-width: 1600px) {
    width: calc(20% - 19.2px); /* 5 cards on very wide screens */
  }
`;
